import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'
import { GetInvoicesParser } from './../network/parsers/GetInvoicesParser'

const responseParser = (data: any) => {
  const respData = GetInvoicesParser(data)
  return respData
}

const getInvoices = (mid: string, year: string, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: `${APIEndPoints.invoice}${mid}?year=${year}`,
    method: 'GET',
    cache: false,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { getInvoices }
